import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 26, className = "", testid }) {
  return (
    <motion.div
      data-testid={testid}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden pb-[0.08em] -mb-[0.08em] ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Marquee({ items, render, duration = 45, className = "" }) {
  return (
    <div className={`marquee ${className}`}>
      <div className="marquee-track" style={{ animationDuration: `${duration}s` }}>
        <div className="marquee-group">{items.map((item, i) => render(item, i))}</div>
        <div className="marquee-group" aria-hidden="true">{items.map((item, i) => render(item, i))}</div>
      </div>
    </div>
  );
}

export function StatCounter({ value, suffix = "", label, testid }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: EASE,
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <div ref={ref} className="text-center sm:text-left" data-testid={testid}>
      <div className="font-mono-alt text-4xl font-bold text-blue-400 sm:text-5xl">
        {display.toLocaleString("en-GB")}
        {suffix}
      </div>
      <p className="mt-2 text-sm font-medium text-slate-300">{label}</p>
    </div>
  );
}
